import React, { useEffect, useState, useRef, useMemo } from "react";
import { Spin, Form, Select, Dropdown, Button as AntDButton } from "antd";
import Button from "../buttons/Button";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js/auto";
import { useStore } from "../../store/index.js";
import { Chart as GChart } from "react-google-charts";
import { MapContainer, GeoJSON, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import Duration from "../../components/duration-filter/duration.jsx"
import { Chart } from "react-chartjs-2";
import "./org-analytics.scss";
import { getRequest } from "../../api/http";
import { useNavigate } from "react-router-dom";
import userServiceApi from "../../api/userServiceApi";
import backArrow from "../../assets/images/back-arrow.svg";
import ReactToPrint from "react-to-print";
import { FilePdfOutlined, DownloadOutlined } from "@ant-design/icons";
import EngagementViewChart from "./EngagementViewChart.jsx";
import { currentMonth } from "../../utils/helper.js";
import { GOOGLE_ANALYTICS_API_URL } from "../../api/http";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function Organalytics() {
  const navigate = useNavigate();
  const orgId = localStorage.getItem("OrgId");
  const currentYear = new Date().getFullYear();
  const { microSites } = useStore();



 const [, setOverallViewCount] = useState();
  const [updatedJSON] = useState();
  const [localLoader] = useState(true);

 const [, setSelectedAgeID] = useState();
  const [selectedAge] = useState();
 const [, setProfessions] = useState();
  const [activeCounty, setActiveCounty] = useState(null);


  const [loader, setLoader] = useState(true);

  const [selected, setSelected] = useState("International");

  const [totalLocal] = useState();

  const [yearDropdownOptions, setYearDropdownOptions] = useState([]);
  const [filterType] = useState();
  const [selectedYear] = useState();
  const [selectedQuarter] = useState();
  const [selectedMonth] = useState();

  const [showYearLocationDropdown, setShowYearLocationDropdown] = useState(false);
  const [locationFilterType, setLocationFilterType] = useState();
  const [showLocationQuarterly, setShowLocationQuarterly] = useState(false);
  const [showLocationMonthly, setShowLocationMonthly] = useState(false);

  const [selectedLocationMonth, setSelectedLocationMonth] = useState();
  const [selectedLocationYear, setSelectedLocationYear] = useState();
  const [selectedLocationQuarter, setSelectedLocationQuarter] = useState();

  const [barChart, setBarChart] = useState(null);


  const [lineGraphData, setLineGraphData] = useState(null);
 const [, setMicrositeData] = useState(null);
  const [, setMicrositesList] = useState();
  const [responseData, setResponseData] = useState([]);
  const [term, setTerm] = useState('yearly');
  const [year, setYear] = useState();
  const [month, setMonth] = useState();
  const [quarter, setQuarter] = useState("1");
  const [visitorsData, setVisitorsData] = useState([]);
  const [topViewedMicroSite, setTopViewedMicroSite] = useState('')
  const [barChartArray, setBarChartArray] = useState([])
  const [publishedArray, setPublishedArray] = useState([])


  const [shareDropdown, setShareDropdown] = useState(false)
  const componentRef = useRef();
  const NATIONAL_COUNTRIES = ["England", "Northern Ireland", "Wales", "Scotland", "United Kingdom"];
  const MonthsArray = [
    { name: "January", value: "01" },
    { name: "February", value: "02" },
    { name: "March", value: "03" },
    { name: "April", value: "04" },
    { name: "May", value: "05" },
    { name: "June", value: "06" },
    { name: "July", value: "07" },
    { name: "August", value: "08" },
    { name: "September", value: "09" },
    { name: "October", value: "10" },
    { name: "November", value: "11" },
    { name: "December", value: "12" },
  ];

  const quarters = [
    { name: "1", months: ["01", "02", "03"] },
    { name: "2", months: ["04", "05", "06"] },
    { name: "3", months: ["07", "08", "09"] },
    { name: "4", months: ["10", "11", "12"] },
  ];

  const getDateRange = (term = "yearly", year = currentYear, month = currentMonth, quarter) => {
    const today = new Date();
    const currentYear = today.getFullYear();


    let startDate, endDate;

    // YEARLY
    if (term === "yearly") {
      if (parseInt(year) === currentYear) {
        // Last 12 months until today
        const pastYear = new Date(today);
        pastYear.setFullYear(today.getFullYear() - 1);
        startDate = `${pastYear.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-01`;
        endDate = today.toISOString().split("T")[0];
      } else {
        startDate = `${year}-01-01`;
        endDate = `${year}-12-31`;
      }
    }

    // MONTHLY
    if (term === "monthly") {
      let monthNumber;

      if (/^\d+$/.test(month)) {
        // If month is a number string or number (e.g., "3" or 3)
        monthNumber = parseInt(month);
        if (monthNumber < 1 || monthNumber > 12) throw new Error(`Invalid month: ${month}`);
      } else {
        // If month is a name (e.g., "March")
        const monthObj = MonthsArray.find(m => m.name.toLowerCase() === month.toLowerCase());
        if (!monthObj) throw new Error(`Invalid month name: ${month}`);
        monthNumber = parseInt(monthObj.value);
      }

      const monthIndex = monthNumber - 1;
      startDate = `${year}-${String(monthNumber).padStart(2, "0")}-01`;
      const end = new Date(year, monthIndex + 1, 0); // Last day of month
      endDate = end.toISOString().split("T")[0];
    }

    // QUARTERLY
    if (term === "quarterly") {
      if (!quarter) throw new Error("Quarter is required for quarterly term");

      const selectedQuarter = quarters.find(q => q.name.toLowerCase() === quarter.toLowerCase());
      if (!selectedQuarter) throw new Error(`Invalid quarter: ${quarter}`);

      const startMonthNumber = parseInt(selectedQuarter.months[0]);
      const endMonthNumber = parseInt(selectedQuarter.months[2]);

      if (startMonthNumber < 1 || startMonthNumber > 12 || endMonthNumber < 1 || endMonthNumber > 12)
        throw new Error(`Invalid months in quarter: ${quarter}`);

      startDate = `${year}-${String(startMonthNumber).padStart(2, "0")}-01`;
      const end = new Date(year, endMonthNumber, 0); // Last day of quarter's end month
      endDate = end.toISOString().split("T")[0];
    }

    return { startDate, endDate };
  };
  const getResponseOfCountry = async () => {
    try {
      setLoader(true)
      const { startDate, endDate } = getDateRange(locationFilterType, selectedLocationYear, selectedLocationMonth, selectedLocationQuarter);
      const response = await fetch(`${GOOGLE_ANALYTICS_API_URL}/country?startDate=${startDate}&endDate=${endDate}`);
      const data = await response?.json();
      setResponseData(data);

      const pathViewers = await fetch(`${GOOGLE_ANALYTICS_API_URL}/path-viewers?startDate=${startDate}&endDate=${endDate}`);
      const pathViewersData = await pathViewers.json();

      // Step 1: Filter valid microsite paths
      const filtered = pathViewersData.filter(item => item.path.startsWith("/microsite/") && !item.path.endsWith("micrositeDetails")) || microSites.filter(item => item?.path?.startsWith("/microsite/") && !item?.path?.endsWith("micrositeDetails"));;
      const micrositeNames = filtered.map(item => {
        const name = item.path.split('/microsite/')[1].replace(/_/g, ' ');
        return { ...item, name };
      });

      const publishedNames = microSites
        .filter(item => item.isPublished)
        .map((item) => ({ id: item?.id, name: item?.name }));

      const nameToIdMap = publishedNames.reduce((acc, item) => {
        acc[item.name] = item.id;
        return acc;
      }, {});

      setPublishedArray(publishedNames)
      // Filter first array based on names present in second array and add id
      const result = micrositeNames
        .filter(item => nameToIdMap[item.name])
        .map(item => ({
          id: nameToIdMap[item.name],
          name: item.name,
          viewers: item.viewers,
          path: item.path,
          month: item.month
        }));
      // setBarChart(result)
      setBarChartArray(result)


      let labels = [];
      let barGraphData = [];
      if (result?.length) {
        result.forEach((microsite) => {
          labels.push(microsite.name);
          barGraphData.push(microsite.viewers);
        });

        setBarChart({
          labels,
          datasets: [
            {
              type: "bar",
              label: "Views",
              backgroundColor: "rgb(2,110,204)",
              data: barGraphData,
              borderColor: "white",
              borderWidth: 2,
              fill: true,
            },
          ],
        });
      }




      // Step 2: Find the maximum viewers
      const maxViewers = Math.max(...result.map(item => item.viewers));

      // Step 3: Get the record(s) with the highest viewers
      const topMicrositeRecords = result.filter(item => item.viewers === maxViewers);
      setTopViewedMicroSite(topMicrositeRecords)



      const visitorsResponseData = await fetch(`${GOOGLE_ANALYTICS_API_URL}/visitors?startDate=${startDate}&endDate=${endDate}`);
      const visitorsData = await visitorsResponseData.json();
      setVisitorsData(visitorsData)





    } catch (e) {
      console.log('error', e)
      setLoader(false)
    } finally {
      setLoader(false)
    }
  }



  useEffect(() => {
    getResponseOfCountry()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationFilterType, selectedLocationYear, selectedLocationMonth, selectedLocationQuarter, microSites])



  const formatCountryData = (responseData = [], pathFilter = null) => {
    if (!Array.isArray(responseData)) {
      return {
        nationalData: [],
        internationalData: [],
        sumOfNational: 0,
        sumOfInternational: 0,
      };
    }

    const national = [];
    const international = [];
    let sumOfNational = 0;
    let sumOfInternational = 0;

    responseData.forEach((item) => {
      // Filter by specific path if provided

      const country = item?.country || "Unknown";
      const viewers = Number(item?.users || 0);
      const tooltip = `${country} - ${viewers} viewers`;

      if (NATIONAL_COUNTRIES.includes(country)) {
        national.push([country, viewers, tooltip]);
        sumOfNational += viewers;
      } else {
        international.push([country, viewers, tooltip]);
        sumOfInternational += viewers;
      }
    });


    return {
      nationalData: [["Country", "Viewers", { role: "tooltip", type: "string" }], ...national],
      internationalData: [["Country", "Viewers", { role: "tooltip", type: "string" }], ...international],
      sumOfNational,
      sumOfInternational,
      total: sumOfInternational + sumOfInternational
    };
  };



 const { nationalData, internationalData, sumOfNational, sumOfInternational } = useMemo(() => { return formatCountryData(responseData);
    // return formatCountryData(countryData);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseData]);



  const optionsGA = {
    backgroundColor: "#f9fafb",
    datalessRegionColor: "#e0e0e0",
    defaultColor: "#f5f5f5",
    legend: { textStyle: { color: "#333" } },
    tooltip: {
      isHtml: true,
    },
    colorAxis: {
      colors: ["#10B981", "#2563EB"], // green → blue gradient
    },
  };



  const getOrgAnalyticsData = async (orgId, selectedMonth, selectedYear, selectedQuarter) => {
    try {
      const res = await getRequest(userServiceApi.orgAnalytics(orgId, selectedMonth, selectedYear, selectedQuarter));
      let labels = [];
      let lineData = [];
      if (res && res.data) {
        res.data.forEach((month) => {
          labels.push(month.monthYear);
          lineData.push(month.count);
        });

        setLineGraphData({
          labels,
          datasets: [
            {
              label: "Views",
              // data: [24, 59, 76, 45, 14, 98, 87, 34, 56, 18, 54, 78],
              data: lineData,
              borderColor: "rgb(255, 99, 132)",
              backgroundColor: "rgba(255, 99, 132, 0.5)",
            },
          ],
        });
      }
    } catch (error) { }
  };

  const getOverallMicrositeData = async (orgId, selectedMonth, selectedYear, selectedQuarter) => {
    try {
      const res = await getRequest(
        userServiceApi.orgOverallMicrositeAnalytics(orgId, selectedMonth, selectedYear, selectedQuarter)
      );
      let labels = [];
      let barGraphData = [];
      if (res && res.data) {
        setMicrositesList(res.data);
        res.data.forEach((microsite) => {
          labels.push(microsite.micrositeName);
          barGraphData.push(microsite.count);
        });

        setMicrositeData({
          labels,
          datasets: [
            {
              type: "bar",
              label: "Views",
              backgroundColor: "rgb(2,110,204)",
              data: barGraphData,
              borderColor: "white",
              borderWidth: 2,
              fill: true,
            },
          ],
        });
      }
    } catch (error) { }
  };

  const getOverallViewCount = async (orgId) => {
    try {
      const res = await getRequest(userServiceApi.overallViewCount(orgId));
      if (res && res.data) {
        setOverallViewCount(res.data);
      }
    } catch (error) {
      console.log('getOverallViewCount : error', error);
    }
  };


  useEffect(() => {
    if (orgId) {
      getOverallViewCount(orgId);
      getOrgAnalyticsData(orgId);
      getOverallMicrositeData(orgId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getYearsDropdown = () => {
    const currentYear = new Date().getFullYear();
    let yearsarray = [];
    for (let year = 2023; year <= currentYear + 20; year++) {
      yearsarray.push(year);
    }
    setYearDropdownOptions(yearsarray);
  };


  useEffect(() => {
    getYearsDropdown();
  }, []);



  // useEffect(() => {
  //   if (orgId) {
  //     getLocationAnalytics(orgId);
  //   }
  // }, [])


  useEffect(() => {
    getOrgAnalyticsData(
      orgId,
      filterType === "monthly" && selectedMonth,
      (filterType === "yearly" ||
        filterType === "monthly" ||
        filterType === "quarterly") &&
      selectedYear,
      filterType === "quarterly" && selectedQuarter
    );
    getOverallMicrositeData(
      orgId,
      filterType === "monthly" && selectedMonth,
      (filterType === "yearly" ||
        filterType === "monthly" ||
        filterType === "quarterly") &&
      selectedYear,
      filterType === "quarterly" && selectedQuarter
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedYear,
    selectedQuarter,
    selectedMonth,
  ]);

  const getProfessions = async () => {
    let id;
    if (selectedAge === "18") {
      id = "3923bb48-79f8-4a9e-98f8-b604137197cc";
    } else if (selectedAge === "22") {
      id = "0ae3762c-d05f-4762-8a02-1ba071fcbcdc";
    } else if (selectedAge === "37") {
      id = "7ab21967-37bc-41ed-8fef-d52247d30acd";
    } else if (selectedAge === "53") {
      id = "7683d02e-8311-4051-aa14-7671fe5bab2f";
    } else {
      id = "2b47e4f5-c72b-4429-973f-8408719c1a53";
    }

    setSelectedAgeID(id);
    try {
      const response = await getRequest(userServiceApi.getProfessions(id));
      if (response) {
        setProfessions(response.data);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    if (
      selectedAge === "18" ||
      selectedAge === "22" ||
      selectedAge === "37" ||
      selectedAge === "53" ||
      selectedAge === "54"
    ) {
      getProfessions();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAge]);

  // useEffect(() => {
  //   getLocationAnalytics(
  //     orgId,
  //     selectedAgeID,
  //     selectedProfID,
  //     ((locationFilterType === "yearly" && selectedLocationYear) ||
  //       (locationFilterType === "monthly" && selectedLocationMonth) ||
  //       (locationFilterType === "quarterly" && selectedLocationQuarter)) &&
  //     locationFilterType,
  //     (locationFilterType === "yearly" ||
  //       locationFilterType === "monthly" ||
  //       locationFilterType === "quarterly") &&
  //     selectedLocationYear,
  //     locationFilterType === "monthly" && selectedLocationMonth,
  //     locationFilterType === "quarterly" && selectedLocationQuarter
  //   );
  // }, [selectedAgeID,
  //   selectedProfID,
  //   selectedLocationYear,
  //   selectedLocationQuarter,
  //   selectedLocationMonth])


  const onClickNavigate = (name) => {
    const result = publishedArray?.find((item) => item?.name === name)
    navigate(`/microsite-analytics/${result?.id}`, { state: { micrositeName: result?.name, page: "organalytics", orgId: orgId } })

  }

  const goToMicroSiteAnalytics = (microsite) => {
    navigate(`/microsite-analytics/${microsite[0].id}`, { state: { micrositeName: microsite[0]?.name, page: "organalytics", orgId: orgId } })

  }
  const handleSelected = (value) => {
    setSelected(value);
  };

  const getColor = (population) => {
    // Implement your own logic to set colors based on population ranges
    return population > 5000
      ? "#032034"
      : population > 1000
        ? "#053656"
        : population > 500
          ? "#074b79"
          : population > 200
            ? "#08619b"
            : population > 100
              ? "#0a76be"
              : population > 50
                ? "#0c8be1"
                : // population > 50 ? '#021523' :
                "#1e9ef3";
    // '#e8300c';
  };



  const BarChartOptions = {
    title: "No. of users based on province",
    // chartArea: { width: "50%" },
    hAxis: {
      title: "Total Population",
      minValue: 0,
    },
    vAxis: {
      title: "Province",
    },
  };

  const BarChartOptions2 = {
    title: "No. of users based on countries",
    // chartArea: { width: "50%" },
    hAxis: {
      title: "Total Population",
      minValue: 0,
    },
    vAxis: {
      title: "Country",
    },
  };

  const OptionsHandler = (value) => {
    return {
      responsive: true,
      scales: {
        x: {
          grid: {
            display: false,
          },
          ticks: {
            color: "black",
          },
          title: {
            display: true,
            text: "Microsites",
            color: "black",
          },
        },
        y: {
          grid: {
            display: false,
          },
          ticks: {
            color: "black",
          },
          title: {
            display: true,
            text: "Number of views",
            color: "black",
          },
        },
      },
      plugins: {
        legend: {
          position: "top",
        },
        title: value,
        datalabels: {
          formatter: Math.round,
          anchor: "end",
          offset: -20,
          align: "start",
        },
      },
      onClick: function (evt, element) {
        // setMicrositeModal(true)
        onClickNavigate(barChart?.labels[element[0]?.index])
        // getMicrositeAnalytics(element[0].index);
      },
    };
  };


  const renderChoroplethMap = () => {
    // Assume 'geoJsonData' is the GeoJSON data for UK counties
    // 'populationData' is the merged population data with GeoJSON data

    const onEachCounty = (county, layer) => {
      layer.on({
        mouseover: (e) => {
          const layer = e.target;
          layer.setStyle({ fillOpacity: 1 });

          const population = layer.feature.properties.population || "0";
          const popupContent = `
                    <b>${layer.feature.properties.ctyua_name}</b><br>
                    No. of people: ${population}
                  `;
          layer.bindPopup(popupContent).openPopup();

          setActiveCounty(layer);
        },
        mouseout: () => {
          if (activeCounty) {
            activeCounty.setStyle({ fillOpacity: 0.9 });
          }
          // activeCounty.closePopup();
        },
      });

      // Use the population data to set style or add popups for each county
      const population = county.properties.population; // Assuming 'name' contains the county name
      if (population >= 1) {
        // Customize styles based on population, for example:
        layer.setStyle({
          fillColor: getColor(population),
          weight: 2,
          color: getColor(population),
          fillOpacity: 0.7,
        });
      } else {
        layer.setStyle({
          fillColor: "#8c8a89",
          weight: 1,
          color: "#8c8a89",
          fillOpacity: 0.4,
        });
      }
    };

    return (
      <MapContainer
        className="map-component"
        center={[54.8, -4.6]}
        zoom={6}
        minZoom={5}
      // style={{ height: '450px', width: '70vw' }}
      >
        <TileLayer
          attribution=""
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {/* Dark mode */}
        {/* <TileLayer
                    // attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
                    attribution=""
                    url='https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png'
                /> */}
        <GeoJSON
          // data={geoJsonData.features}
          data={updatedJSON.features}
          onEachFeature={onEachCounty}
        />
      </MapContainer>
    );
  };

    return (
      <div ref={componentRef} className="tabContainer analytics-tab">
        <div className="header page-header" style={{ width: '100%' }} >
          <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }} >
              <div className="backbtn-container">
                <img src={backArrow} alt="" onClick={() => navigate('/')} />
                <p>Engagement</p>
              </div>
              <div>
                <Dropdown
                  open={shareDropdown}
                  trigger={["click"]}
                  placement="bottomRight"
                  arrow={false}
                  onOpenChange={(open, e) => setShareDropdown(open)}
                  overlay={
                    <div
                      className="dropdown"
                      style={{
                        border: "1px solid #3067AE",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                        width: "190px",
                      }}
                    >
                      <>
                        <ReactToPrint
                          copyStyles={true}
                          content={() => componentRef.current}
                          trigger={() => {
                            return (
                              <div
                                style={{
                                  padding: "13px",
                                  borderBottom: "1px solid #f0f0f0",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  className="dropdown-items"
                                  style={{
                                    display: "flex",
                                    alignItems: 'center'
                                  }}
                                >
                                  <FilePdfOutlined className="pdf-icon" />
                                  <label
                                    style={{
                                      marginLeft: "10px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Download as PDF
                                  </label>
                                </div>
                              </div>
                            );
                          }}
                        ></ReactToPrint>
                      </>
                    </div>
                  }
                >
                  <AntDButton type="primary" icon={<DownloadOutlined />} style={{ backgroundColor: '#3067ae' }} > Download viewership data</AntDButton>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
        <div className="filter-box">
          <div className="add-filter-btns">
            <Form.Item className="term-select" label="Term" colon={false}>
              <Select
                allowClear
                className="customSelect"
                placeholder="Select Term"
                value={locationFilterType}
                onChange={(e) => {
                  setLocationFilterType(e);
                  setTerm(e)
                  if (e === "quarterly") {
                    setShowLocationMonthly(false);
                    setSelectedLocationMonth();
                    setSelectedLocationYear();
                    setSelectedLocationQuarter();
                    setShowYearLocationDropdown(true);
                    setShowLocationQuarterly(true);
                  } else if (e === "monthly") {
                    setSelectedLocationMonth();
                    setSelectedLocationYear();
                    setSelectedLocationQuarter();
                    setShowYearLocationDropdown(true);
                    setShowLocationQuarterly(false);
                    setShowLocationMonthly(true);
                  } else if (e === "yearly") {
                    setSelectedLocationMonth();
                    setSelectedLocationYear();
                    setSelectedLocationQuarter();
                    setShowLocationMonthly(false);
                    setShowLocationQuarterly(false);
                    setShowYearLocationDropdown(true);
                  }
                }}
                onClear={() => {
                  setLocationFilterType();
                  setSelectedLocationYear();
                  setSelectedLocationMonth();
                  setSelectedLocationQuarter();
                  setShowYearLocationDropdown(false);
                  setShowLocationMonthly(false);
                  setShowLocationQuarterly(false);
                }}
                options={[
                  {
                    value: "yearly",
                    label: "Yearly",
                  },
                  {
                    value: "monthly",
                    label: "Monthly",
                  },
                  {
                    value: "quarterly",
                    label: "Quarterly",
                  },
                ]}
              ></Select>
            </Form.Item>
            {showYearLocationDropdown && (
              <Form.Item className="term-select" label="Year" colon={false}>
                <Select
                  allowClear
                  className="customSelect"
                  placeholder="Select Year"
                  value={selectedLocationYear}
                  onChange={(e) => {
                    setSelectedLocationYear(e);
                    setYear(e);
                  }}
                  onClear={() => {
                    setSelectedLocationYear();
                    setSelectedLocationMonth();
                    setSelectedLocationQuarter();
                    setShowLocationQuarterly(false);
                    setShowLocationMonthly(false);
                    setShowYearLocationDropdown(false);
                    setLocationFilterType();
                  }}
                >
                  {yearDropdownOptions.length > 0 &&
                    yearDropdownOptions.map((year, i) => (
                      <Select.Option
                        disabled={year > currentYear ? true : false}
                        key={year}
                        value={year}
                      >
                        {year}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            )}
            {showLocationMonthly && (
              <Form.Item className="term-select" label="Month" colon={false}>
                <Select
                  allowClear
                  className="customSelect"
                  disabled={selectedLocationYear ? false : true}
                  placeholder="Select Month"
                  value={selectedLocationMonth}
                  onChange={(e) => {
                    setSelectedLocationMonth(e);
                    setMonth(e)
                  }}
                  onClear={() => {
                    setSelectedLocationMonth();
                    setSelectedLocationYear();
                  }}
                  options={[
                    { value: "1", label: "January" },
                    { value: "2", label: "February" },
                    { value: "3", label: "March" },
                    { value: "4", label: "April" },
                    { value: "5", label: "May" },
                    { value: "6", label: "June" },
                    { value: "7", label: "July" },
                    { value: "8", label: "August" },
                    { value: "9", label: "September" },
                    { value: "10", label: "October" },
                    { value: "11", label: "November" },
                    { value: "12", label: "December" },
                  ]}
                ></Select>
              </Form.Item>
            )}
            {showLocationQuarterly && (
              <Form.Item className="term-select" label="Quarter" colon={false}>
                <Select
                  allowClear
                  className="customSelect"
                  placeholder="Select Quarter"
                  value={selectedLocationQuarter}
                  disabled={selectedLocationYear ? false : true}
                  onChange={(e) => {
                    setSelectedLocationQuarter(e);
                    setQuarter(e)
                  }}
                  onClear={() => {
                    setSelectedLocationQuarter();
                    setSelectedLocationYear();
                  }}
                  options={[
                    {
                      value: "1",
                      label: "Q1",
                    },
                    {
                      value: "2",
                      label: "Q2",
                    },
                    {
                      value: "3",
                      label: "Q3",
                    },
                    {
                      value: "4",
                      label: "Q4",
                    },
                  ]}
                ></Select>
              </Form.Item>
            )}
          </div>
        </div>

        <div className="overall-views-graph">
         {loader ? <div className="data-loader">
                        <Spin
                          className="loading-svg"
                          tip="Loading"
                          size="large"
                        />
                      </div> :  <div className="microsite-data">
            
            <div className="selection-container" style={{ display: "flex", alignItems: "center" }}>
              <Duration
                // options={["Local", "National", "International"]}
                options={["National", "International"]}

                selected={handleSelected}
              />
              <div className="user-count">
                <p className="total-count">
                  {/* {selected === "Local"
                    ? totalLocal
                    : selected === "National"
                      ? totalNational
                      : totalInternational} */}
                  {selected === "Local"
                    ? totalLocal
                    : selected === "National"
                      ? sumOfNational
                      : sumOfInternational}
                </p>
                <div className="count-label">
                  <p>{`${selected === "Local"
                    ? `Local`
                    : selected === "National"
                      ? `National`
                      : `International`
                    }`}</p>
                  <p>No. of users</p>
                </div>
              </div>
            </div>
            <div className="users-by-map">
              {selected === "Local" ? (
                <div className="charts">
                  {
                    !localLoader && updatedJSON ? (
                      <div className="local-chart">
                        {Object.keys(updatedJSON).length === 0 && (
                          <div>Loading...</div>
                        )}
                        {Object.keys(updatedJSON).length > 0 &&
                          renderChoroplethMap()}
                        <div>
                          <div className="gradient-legend"></div>
                          <div className="text-legend">
                            <div className="start">
                              <p style={{ marginLeft: "0px" }}>less than 50</p>
                            </div>
                            <div className="end">
                              <p style={{ marginRight: "0px" }}>
                                greater than 5000
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="data-loader">
                        <Spin
                          className="loading-svg"
                          tip="Loading"
                          size="large"
                        />
                      </div>
                    )}
                </div>
              ) : selected === "National" ? (
                // nationalUsers?.length > 1 ? (
                nationalData?.length > 1 ? (

                  <div className="charts">
                    <div className="geoChart">
                      {/* <GChart
                        // className="geoChart"
                        className="gchart"
                        chartType="GeoChart"
                        width="100%"
                        height="400px"
                        loader={true}
                        // data={data}
                        data={nationalUsers}
                        options={options}
                      /> */}

                      <GChart
                        // className="geoChart"
                        className="gchart"
                        chartType="GeoChart"
                        width="100%"
                        height="400px"
                        loader={true}
                        // data={data}
                        data={nationalData}
                        options={optionsGA}
                      />
                    </div>
                    <div className="barChart">
                      {/* <GChart
                        // className="barChart"
                        className="gchart"
                        chartType="BarChart"
                        width="100%"
                        height="400px"
                        loader={true}
                        // data={data}
                        data={nationalUsers}
                        options={BarChartOptions}
                      /> */}
                      <GChart
                        // className="barChart"
                        className="gchart"
                        chartType="BarChart"
                        width="100%"
                        height="400px"
                        loader={true}
                        // data={data}
                        data={nationalData}
                        options={BarChartOptions}
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <p className="sub-header">No data available</p>
                  </>
                )
                // ) : internationalUsers?.length > 1 ? (
              ) : internationalData?.length > 1 ? (

                <div className="charts">
                  <div className="geoChart" style={{ height: "500px" }}>
                    {/* <GChart
                      // className="geoChart"
                      className="gchart"
                      chartType="GeoChart"
                      // width="650px"
                      height="400px"
                      width="100%"
                      // height="100%"
                      data={internationalUsers}
                      options={options2}
                    /> */}
                    <GChart
                      // className="geoChart"
                      className="gchart"
                      chartType="GeoChart"
                      // width="650px"
                      height="400px"
                      width="100%"
                      // height="100%"
                      data={internationalData}
                      options={optionsGA}
                    />
                  </div>
                  <div className="barChart" style={{ height: "500px" }}>
                    {/* <GChart
                      className="gchart"
                      chartType="BarChart"
                      width="100%"
                      height="400px"
                      data={internationalUsers}
                      options={BarChartOptions2}
                    /> */}
                    <GChart
                      className="gchart"
                      chartType="BarChart"
                      width="100%"
                      height="400px"
                      data={internationalData}
                      options={BarChartOptions2}
                    />
                  </div>
                </div>
              ) : (
                <p className="sub-header">No data available</p>
              )}
            </div>
          </div>}
        </div>
        <h2 className="all-time-count">
          <b>Organisation Statistics</b>
        </h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {/* <div className="filter-box">
            <div className="add-filter-btns">
              <Form.Item className="term-select" label="Term" colon={false}>
                <Select
                  allowClear
                  className="customSelect"
                  // placeholder={firstValue}
                  placeholder="Select Term"
                  value={filterType}
                  onChange={(e) => {
                    setFilterType(e);
                    setTerm(e)
                    if (e == "quarterly") {
                      setShowMonthly(false);
                      setSelectedMonth();
                      setSelectedYear();
                      setSelectedQuarter();
                      setShowYearDropdown(true);
                      setShowQuarterly(true);
                    } else if (e == "monthly") {
                      setSelectedMonth();
                      setSelectedYear();
                      setSelectedQuarter();
                      setShowYearDropdown(true);
                      setShowQuarterly(false);
                      setShowMonthly(true);
                    } else if (e == "yearly") {
                      setSelectedMonth();
                      setSelectedYear();
                      setSelectedQuarter();
                      setShowMonthly(false);
                      setShowQuarterly(false);
                      setShowYearDropdown(true);
                    }
                  }}
                  onClear={() => {
                    setFilterType();
                    setSelectedYear();
                    setSelectedMonth();
                    setSelectedQuarter();
                    setShowYearDropdown(false);
                    setShowMonthly(false);
                    setShowQuarterly(false);
                  }}
                  options={[
                    {
                      value: "yearly",
                      label: "Yearly",
                    },
                    {
                      value: "monthly",
                      label: "Monthly",
                    },
                    {
                      value: "quarterly",
                      label: "Quarterly",
                    },
                  ]}
                ></Select>
              </Form.Item>
              {showYearDropdown && (
                <Form.Item className="term-select" label="Year" colon={false}>
                  <Select
                    allowClear
                    className="customSelect"
                    // placeholder={firstValue}
                    placeholder="Select Year"
                    value={selectedYear}
                    onChange={(e) => {
                      setSelectedYear(e);
                      setYear(e)
                    }}
                    onClear={() => {
                      setSelectedYear();
                      setSelectedMonth();
                      setSelectedQuarter();
                      setShowQuarterly(false);
                      setShowMonthly(false);
                      setShowYearDropdown(false);
                      setFilterType();
                      setYear()
                    }}
                  >
                    {yearDropdownOptions.length > 0 &&
                      yearDropdownOptions.map((year, i) => (
                        <Select.Option
                          disabled={year > currentYear ? true : false}
                          key={year}
                          value={year}
                        >
                          {year}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              )}
              {showMonthly && (
                <Form.Item className="term-select" label="Month" colon={false}>
                  <Select
                    allowClear
                    className="customSelect"
                    // placeholder={firstValue}
                    disabled={selectedYear ? false : true}
                    placeholder="Select Month"
                    value={selectedMonth}
                    onChange={(e) => {
                      setSelectedMonth(e);
                      setMonth(e)
                    }}
                    onClear={() => {
                      setSelectedMonth();
                      setSelectedYear();
                      setYear()
                      setMonth()

                      // setFilterType();
                      // setShowMonthly(false);
                      // setShowYearDropdown(false);
                    }}
                    options={[
                      { value: "January", label: "January" },
                      { value: "February", label: "February" },
                      { value: "March", label: "March" },
                      { value: "April", label: "April" },
                      { value: "May", label: "May" },
                      { value: "June", label: "June" },
                      { value: "July", label: "July" },
                      { value: "August", label: "August" },
                      { value: "September", label: "September" },
                      { value: "October", label: "October" },
                      { value: "November", label: "November" },
                      { value: "December", label: "December" },
                    ]}
                  ></Select>
                </Form.Item>
              )}
              {showQuarterly && (
                <Form.Item className="term-select" label="Quarter" colon={false}>
                  <Select
                    allowClear
                    className="customSelect"
                    // placeholder={firstValue}
                    placeholder="Select Quarter"
                    value={selectedQuarter}
                    disabled={selectedYear ? false : true}
                    onChange={(e) => {
                      setSelectedQuarter(e);
                      setQuarter(e);
                    }}
                    onClear={() => {
                      setSelectedQuarter();
                      // setFilterType();
                      setSelectedYear();
                      setYear();
                      setQuarter();
                      // setShowQuarterly(false);
                      // setShowYearDropdown(false);
                    }}
                    options={[
                      {
                        value: "1",
                        label: "Q1",
                      },
                      {
                        value: "2",
                        label: "Q2",
                      },
                      {
                        value: "3",
                        label: "Q3",
                      },
                      {
                        value: "4",
                        label: "Q4",
                      },
                    ]}
                  ></Select>
                </Form.Item>
              )}
            </div>
          </div> */}
          <div className="overall-views-graph">
            {lineGraphData ? (
              <div className="microsite-data">
                <h2 className="all-time-count">
                  {/* <b>All time Organisation viewership</b> <span> {overallViewCount ?? 0} views</span> */}
                  <b>All time Organisation viewership</b> <span> {sumOfInternational + sumOfNational} views</span>

                </h2>
                <EngagementViewChart responseData={visitorsData} micrositeName={''} term={term} year={year || currentYear} monthName={month} quarter={quarter} />
                {/* <div className="graph-wrapper">
                  <Line
                    options={Lineoptions}
                    height="80%"
                    data={lineGraphData}
                  />
                </div> */}
              </div>
            ) : (
              <div className="data-loader">
                <Spin tip="Loading" size="large" />
              </div>
            )}
          </div>
          {/* <div className="overall-views-graph">
            {micrositesList && micrositesList?.length > 1 ? (


              <>
                {micrositeData ? (
                  <div className="microsite-data">
                    <h2 className="all-time-count">
                      <b>Top performing microsites</b>
                    </h2>
                    <div className="graph-wrapper">
                      <Chart
                        type="bar"
                        height="80%"
                        data={micrositeData}
                        options={OptionsHandler("complaintNumber")}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="data-loader">
                    <Spin tip="Loading" size="large" />
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="microsite-data">
                  <h2 className="all-time-count">
                    <b>Top performing microsites</b>
                  </h2>
                  {micrositesList.length > 0 ? (
                    <div className="microsite-info">
                      <div className="microsite-name">
                       
                        {topViewedMicroSite && topViewedMicroSite[0]?.path.split('/')[2].replace('_', ' ')}
                      </div>
                      <div className="microsite-count">
                        {topViewedMicroSite && topViewedMicroSite[0]?.viewers} views

                      </div>
                      <Button
                        label="View microsite analytics"
                        className="greenBtn view-microsite-anaytics-btn"
                        width="200px"
                        onClick={() => {
                          getMicrositeAnalytics(0);
                        }}
                      />
                    </div>
                  ) : (
                    <div>
                      <h3 style={{ textAlign: 'center' }}>No microsites available</h3>
                    </div>
                  )}

                </div>
              </>
            )}
          </div> */}

          <div className="overall-views-graph">
            {barChartArray && barChartArray?.length > 1 ? (
              <>
                {barChart ? (
                  <div className="microsite-data">
                    <h2 className="all-time-count">
                      <b>Top performing microsites</b>
                    </h2>
                    <div className="graph-wrapper">
                      <Chart
                        type="bar"
                        height="80%"
                        data={barChart}
                        options={OptionsHandler("complaintNumber")}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="data-loader">
                    <Spin tip="Loading" size="large" />
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="microsite-data">
                  <h2 className="all-time-count">
                    <b>Top performing Sites</b>
                  </h2>
                  {topViewedMicroSite.length > 0 ? (
                    <div className="microsite-info">
                      <div className="microsite-name">

                        {topViewedMicroSite && topViewedMicroSite[0]?.name}
                      </div>
                      <div className="microsite-count">
                        {topViewedMicroSite && topViewedMicroSite[0]?.viewers} views

                      </div>
                      <Button
                        label="View sites analytics"
                        className="greenBtn view-microsite-anaytics-btn"
                        width="200px"
                        onClick={() => {
                          // getMicrositeAnalytics(0);
                          goToMicroSiteAnalytics(topViewedMicroSite)
                        }}
                      />
                    </div>
                  ) : (
                    <div>
                      <h3 style={{ textAlign: 'center' }}>No sites available</h3>
                    </div>
                  )}

                </div>
              </>
            )}
          </div>
        </div>
      </div >
    );
  // }
}
